import CourseEnrollmentService from '@/services/API/CourseEnrollmentService';
import UserService from '@/services/API/UserService';

import { ATTESTATION_STATUSES } from '@/modules/CourseManagement/constants';

import Base from '../Base';

export default class UserRecord extends Base {
  constructor(item, params) {
    super(item.record.id, '/prior-record-users');

    this.user_id = item.id;
    this.full_name = item.full_name;
    this.passed_course_unit_count = item.passed_course_unit_count;
    this.course_tasks = item.course_tasks;
    this.record = item.record;
    this.name = item.name;
    this.status = item.record.status;
    this.attributes = item.attributes || [];
    this.statements = item.statements || [];
    this.progress = [];
    this.isValidAttrs = false;
    this.payment_percent = item.payment_percent || 0;

    this.diplomData = null;
    this.params = params || {};
  }

  get isValidState() {
    if (Object.hasOwn(this.params, 'is_enrollment_scan_required')) {
      const scanRequired = this.params.is_enrollment_scan_required;
      if (scanRequired) {
        return this.statements.every((i) => i.user_file);
      }
      if (this.statements.length === 1) return true;
      return this.statements.filter(({ document_name: name }) => name !== 'Заявление на зачисление').every((i) => i.user_file);
    }
    return this.statements.every((i) => i.user_file);
  }

  get scanRequired() {
    return this.params.is_enrollment_scan_required;
  }

  get statusColor() {
    const COLORS = {
      [ATTESTATION_STATUSES.enrolled]: 'grey',
      [ATTESTATION_STATUSES.allowedAttestation]: 'secondary',
      [ATTESTATION_STATUSES.attestated]: 'success',
      [ATTESTATION_STATUSES.refusedAttestation]: 'error',
    };
    return COLORS[this.status] || 'grey';
  }

  validAttributes() {
    this.isValidAttrs = (!this.attributes || !this.attributes.length) || this.attributes
      .every((i) => (i.value || !i.is_required));
  }

  get statusEnrollmentColor() {
    const COLORS = {
      [ATTESTATION_STATUSES.enrolled]: 'success',
      [ATTESTATION_STATUSES.allowedAttestation]: 'success',
      [ATTESTATION_STATUSES.attestated]: 'success',
      [ATTESTATION_STATUSES.refusedAttestation]: 'success',

      [ATTESTATION_STATUSES.excluded]: 'error',
    };
    return COLORS[this.status] || 'grey';
  }

  get statusEnrollmentIcon() {
    if (this.status === ATTESTATION_STATUSES.excluded) {
      return this.record.group ? 'mdi-account-cancel' : 'mdi-cancel';
    }
    return 'mdi-account';
  }

  async fetchStudentProgress(courseId) {
    const { items } = await UserService.courses(this.user_id, {
      expand: 'course_units',
      'search[id]': courseId,
    });
    const [course] = items;
    this.progress = course.units;
  }

  setupAttributes(allAttrs) {
    this.attributes = allAttrs.map(
      (i) => this.attributes.find((attr) => i.id === attr.id) || { ...i, value: null },
    );
    this.validAttributes();
  }

  async changeStatus(data) {
    const resp = await CourseEnrollmentService.changeStatus(this.id, data);
    this.status = resp.data.data.status;
    if (data.reason) {
      this.record.reason = resp.data.data.reason;
    }
  }

  allowAttestation() {
    return this.changeStatus({ status: ATTESTATION_STATUSES.allowedAttestation });
  }

  attestate() {
    return this.changeStatus({ status: ATTESTATION_STATUSES.attestated });
  }

  refuseAttestation() {
    return this.changeStatus({ status: ATTESTATION_STATUSES.refusedAttestation });
  }

  async setGroup(group) {
    await this.changeStatus({ group_id: group.id });
    this.record.group = group;
  }

  async enroll(group) {
    const payloads = {
      status: ATTESTATION_STATUSES.enrolled,
    };
    if (group) {
      payloads.group_id = group.id;
    }
    await this.changeStatus(payloads);
    if (group) this.record.group = group;
  }

  exclude(reason) {
    return this.changeStatus({ status: ATTESTATION_STATUSES.excluded, reason });
  }

  async fetchDiplomData(enrollmentId) {
    const resp = await CourseEnrollmentService.indexUPK({
      'search[prior_record_id]': enrollmentId,
      'search[owner_id]': this.user_id,
    });
    const [diplomData] = resp.data.data;
    this.diplomData = diplomData;
  }
}
